<template>
<b-alert variant="danger" dismissible :show = hasErrors >
    <strong>Errors with the form submission, please correct and re-submit</strong>
    <div v-for="(error, index) in activeErrorMessages" :key="index">
      <slot
        :error-message="error"
        :error="activeErrors[index]">
        {{ error }}
      </slot>
    </div>
</b-alert>
</template>


<script>
import { multiErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  inheritAttrs: false,
  extends: multiErrorExtractorMixin
}
</script>